/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateBankSuffixToPlaidMaskRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/UpdateBankSuffixToPlaidMask.pb'
import {UpdateBankSuffixToPlaidMaskResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/UpdateBankSuffixToPlaidMask.pb'


export const updateBankSuffixToPlaidMask = (request:UpdateBankSuffixToPlaidMaskRequest, options?: CashRequestOptions) => post<UpdateBankSuffixToPlaidMaskRequest, UpdateBankSuffixToPlaidMaskResponse>("/2.0/cash/update-bank-suffix-to-plaid-mask", request, {...options, rejectOnError: true })